import { Analytics } from 'firebase/analytics';

import { FirebaseErrorLogger } from '../../../Domain/Port/firebase-error.logger';
import { FirebaseCapacitorEventRepository } from '../../../Infrastructure/Adapter/Firebase/FirebaseCapacitor/firebase-capacitor-event-repository.service';
import { FirebaseWebEventRepository } from '../../../Infrastructure/Adapter/Firebase/FirebaseWeb/firebase-web-event-repository.service';

/**
 * Factory function to create the appropriate EventRepository based on the platform
 */
export function eventRepositoryFactory(
    isNativePlatform: boolean,
    firebaseErrorLogger: FirebaseErrorLogger,
    analytics: Analytics
) {
    if (!firebaseErrorLogger) {
        throw new Error('FirebaseErrorLogger must be provided');
    }

    return isNativePlatform
        ? new FirebaseCapacitorEventRepository(firebaseErrorLogger)
        : new FirebaseWebEventRepository(analytics, firebaseErrorLogger);
}
